import { Col, P } from 'ia-react-core';
import styled from 'styled-components';

export const StyledTextLeft = styled(Col)`
  margin-top: 0px !important;
  text-align:left;
`;
export const StyledTextRight = styled(Col)`
  margin-top: 0px !important;
  text-align:right;
`;

export const StyledMailContent = styled.div`
  margin-bottom: 0px;
  `;

export const StyledMailText = styled(P)`
  white-space: break-spaces;
  margin-top: 4px;
  overflow-wrap: break-word;
`;
